import React from 'react';
import { Adjustment } from './interfaces';

import editSvg from '../../../../assets/edit.svg';
import deleteSvg from '../../../../assets/delete.svg';

const AdjustmentsList = ({
  adjustments,
  onEditClick,
  onDeleteClick,
}: {
  adjustments: Adjustment[];
  onEditClick: (adjustment: Adjustment) => void;
  onDeleteClick: (name: number) => void;
}) => {
  return (
    <div>
      <div>
        <div
          style={{
            ...styles.header,
            position: 'sticky',
            top: 0,
          }}
        >
          <div style={{ flex: 1, textAlign: 'left' }}>Adjustment set</div>
          <div style={{ flex: 1 }}>Parameter</div>
          <div style={{ width: '5.6vh' }}>Floor plan</div>
          <div style={{ width: '5.6vh' }}>Value</div>
          <div style={{ width: '4.8vh' }}></div>
        </div>
        {adjustments
          .sort((a, b) => a.setname.toLowerCase().localeCompare(b.setname.toLowerCase()))
          .map((adjustment, index) => (
            <AdjustmentCard
              setname={adjustment.setname}
              config={adjustment.config}
              name={adjustment.name}
              value={adjustment.value}
              onEdit={() => onEditClick(adjustment)}
              onDelete={() => onDeleteClick(adjustment.rowid)}
            />
          ))}
      </div>
    </div>
  );
};

interface AdjustmentCardProps {
  setname: string;
  config: string;
  name: string;
  value: string | number;
  onEdit: () => void;
  onDelete: () => void;
}

const AdjustmentCard: React.FC<AdjustmentCardProps> = ({ setname, config, name, value, onEdit, onDelete }) => {
  return (
    <div style={styles.card}>
      <div style={styles.cardDetails}>
        <span style={{ flex: 1, textAlign: 'left' }}>{setname}</span>
        <span style={{ flex: 1 }}>{name}</span>
        <span style={{ width: '5.6vh' }}>{config}</span>
        <span style={{ width: '5.6vh' }}>${value}</span>
        <div style={{ display: 'flex', width: '4.8vh' }}>
          <button style={styles.iconButton} onClick={onEdit}>
            <img src={editSvg} alt="Edit" style={{ width: '1.6vh', height: '1.6vh' }} />
          </button>
          <div style={{ width: '0.8vh' }}></div>
          <button style={styles.iconButton} onClick={onDelete}>
            <img src={deleteSvg} alt="Delete" style={{ width: '1.6vh', height: '1.6vh' }} />
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    width: '100%',
    margin: '0 auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#f8f8f9',
    color: 'rgba(16, 29, 59, 0.6)',
    height: '4.4vh',
    borderBottom: '0.1vh solid #e1e2e6',
    padding: '0vh 1.6vh',
    fontSize: '1.2vh',
    fontWeight: '700',
  },
  addButton: {
    backgroundColor: 'transparent',
    border: 'none',
    color: 'rgba(16, 29, 59, 0.6)',
    fontSize: '2.0vh',
    cursor: 'pointer',
  },
  card: {
    color: 'rgba(16, 29, 59, 1)',
    padding: '0.8vh 1.6vh',
    borderRadius: '0.4vh',
    borderBottom: '0.1vh solid #e1e2e6',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.4vh',
    fontWeight: '400',
  },
  iconButton: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#fff',
    cursor: 'pointer',
  },
  cardDetails: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '0.4vh',
    fontSize: '1.4vh',
    fontWeight: '400',
  },
};

export default AdjustmentsList;
